{
    "update_password": {
        "title": "Modifier le mot de passe",
        "success": "Mot de passe modifié avec succès !",
        "current_password": "Mot de passe actuel",
        "new_password": "Choisissez un nouveau mot de passe",
        "confirm_password": "Confirmez le nouveau mot de passe",
        "passwords_mismatch": "Les mots de passe ne correspondent pas.",
        "passwords_match": "Les mots de passe sont identiques"
    },
    "mfa": {
        "application": "Téléchargez l'application Google Authenticator ou une autre application d'authentification sur votre appareil mobile :",
        "attempts_info_init_plural": "Il vous reste {{attempts}} tentatives",
        "attempts_info_init_singular": "Il vous reste {{attempts}} tentative",
        "cancel_message": "Vous pouvez à tout moment activer l'authentification à double facteur dans le portail depuis votre compte utilisateur.",
        "cgu": {
            "title": "Conditions Générales d’Utilisation",
            "sub_title": "Les présentes conditions générales d'utilisation s'appliquent à tous les utilisateurs du site ",
            "articles": {
                "1": {
                    "title": "Article 1 : Mentions légales",
                    "content": [
                        {
                            "type": "highlight",
                            "label": "Raison sociale : ",
                            "text": "{{rootOrganization.legalName}}"
                        },
                        {
                            "type": "text",
                            "text": "Siège social : {{rootOrganization.address}}"
                        },
                        {
                            "type": "text",
                            "text": "SIRET : {{rootOrganization.registrationNumber}}",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Editeur : PRELUDD PAYMENT SERVICES"
                        },
                        {
                            "type": "text",
                            "text": "Siège social : 3 boulevard Henri Ziegler, 31700 BLAGNAC, France"
                        },
                        {
                            "type": "textLink",
                            "label": "Email : ",
                            "text": "support@preludd.com",
                            "href": "mailto:support@preludd.com"
                        },
                        {
                            "type": "text",
                            "text": "SIRET : 82304150400015 (RCS de TOULOUSE)"
                        },
                        {
                            "type": "text",
                            "text": "Numéro de TVA intracommunautaire : FR00823041504"
                        },
                        {
                            "type": "text",
                            "text": " Capital social : 56 250.40 €",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Hébergeur : PRELUDD PAYMENT SERVICES"
                        },
                        {
                            "type": "text",
                            "text": "Siège social : 3 boulevard Henri Ziegler, 31700 BLAGNAC, France"
                        },
                        {
                            "type": "textLink",
                            "label": "Email : ",
                            "text": "support@preludd.com",
                            "href": "mailto:support@preludd.com"
                        }
                    ]
                },
                "2": {
                    "title": "Article 2 : Fonctionnalités",
                    "content": [
                        {
                            "type": "link",
                            "text": "Le portail monéticien est accessible selon le lien suivant ",
                            "label": "{{getPortalAddress()}}",
                            "href": "https://{{getPortalAddress()}}",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Le monéticien pourra activer l’authentification multi-facteur."
                        }
                    ]
                },
                "3": {
                    "title": "Article 3 : Modalités d’Utilisation",
                    "content": [
                        {
                            "type": "text",
                            "text": "Cette authentification multi-facteur est fondée sur deux facteurs, le facteur de connaissance qui correspond au login fourni ainsi qu’au renseignement d’un mot de passe. Puis par le biais d’un second facteur qui correspond à celui de possession, ce qui signifie que l’Utilisateur devra installer une application d’authentification."
                        }
                    ]
                },
                "4": {
                    "title": "Article 4 : Modifications et évolutions",
                    "content": [
                        {
                            "type": "text",
                            "text": "En cas de modifications ou évolutions majeures de cette fonctionnalité, ces dernières apparaîtront dans une fenêtre sur l’accueil du site.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Le monéticien est réputé accepter toutes modifications ou évolutions de cette fonctionnalité, en l’absence de contestation dans un délai de 15 jours à compter de l’information de la modification ou de l’évolution.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Pour contester, le monéticien devra se rapprocher du service support.",
                            "separator": true
                        }
                    ]
                },
                "5": {
                    "title": "Article 5 : Traitement des données personnelles",
                    "content": [
                        {
                            "type": "text",
                            "text": "Toutes les mesures nécessaires permettant de garantir la sécurité et la confidentialité des informations et des données personnelles, sont prises par l’éditeur.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Les informations transmises par l’Utilisateur restent sous le contrôle de ce dernier et doivent respecter les lois et règlement en vigueur. Il peut à tout moment les modifier ou les supprimer."
                        }
                    ]
                },
                "6": {
                    "title": "Article 6 : Engagement et responsabilité",
                    "content": [
                        {
                            "type": "text",
                            "text": "Le monéticien est tenu comme responsable des données qui lui appartient au sein de cette fonctionnalité.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Le monéticien s’engage à préserver la confidentialité des informations.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "Le monéticien s’engage à respecter toutes les lois, règles et règlements applicables ainsi que les normes techniques applicables à la fonctionnalité.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "L’éditeur du site est tenue à une obligation de moyens de fournir le service, étant dépendant des différents opérateurs réseaux, il ne pourra être tenu responsable d’inaccessibilité du site, sauf dans le cas où il s’agit d’un manquement imputable.",
                            "separator": true
                        },
                        {
                            "type": "text",
                            "text": "La responsabilité de l’éditeur ne peut pas être engagée en cas d’une utilisation de la fonctionnalité consécutive à une divulgation, une perte ou un vol des codes d’accès ou des données, ainsi qu’en cas d’utilisation non conforme de la fonctionnalité.",
                            "separator": true
                        }
                    ]
                },
                "7": {
                    "title": "Article 7 : Propriété intellectuelle",
                    "content": [
                        {
                            "type": "text",
                            "text": "L’éditeur déclare posséder tous les droits et autorisations permettant au monéticien d’utiliser le service et en contrepartie celui-ci reconnait que le site n’est pas de sa propriété."
                        }
                    ]
                }
            }
        },
        "cgu_title": "Veuillez lire et accepter les conditions d'utilisation avant de continuer :",
        "code_validation": "Saisissez le code fourni par votre application :",
        "confirm_activation_message": "Voulez-vous activer l'authentification à double facteur pour sécuriser le portail ?",
        "confirm_deactivation_message": "L'authentification à double facteur est déjà activée pour ce compte, voulez-vous la désactiver ?",
        "deactivation_title": "Désactivation de l'authentification à double facteur",
        "deactivation_ongoing": "Désactivation de l'authentification à double facteur en cours",
        "deactivation_success": "L'authentification à double facteur a été désactivée avec succès",
        "deactivation_error": "Une erreur est survenue. L'authentification à double facteur n'a pas pu être désactivée",
        "fetch_error": "Une erreur est survenue. Si l'erreur persiste, veuillez contactez le support.",
        "init_success": "L'authentification à double facteur est activée",
        "init_error": "L'activation de l'authentification à double facteur a échoué",
        "init_title": "Authentification à double facteur",
        "modal_title": "Activation de l'authentification à double facteur",
        "qrcode": "Lisez ce QRcode à l'aide de votre application pour la synchroniser :",
        "remove_modal_title": "Désactiver l'authentification à double facteur",
        "remove_text_validation": "Êtes vous sûr de vouloir désactiver l'authentification à double facteur ?",
        "remove_email_information": "Si oui, le lien de désactivation sera envoyé à votre email : ",
        "remove_email_warning": "L'email a bien été envoyé. Si vous ne l'avez pas reçu, veuillez consulter votre dossier spam ou indésirables",
        "remove_email_missing": "Email manquant",
        "remove_send_email_error": "Une erreur est survenue"
    },
    "modal": {
        "reload_page": {
            "title": "Mise à jour disponible",
            "text": "Une nouvelle version du portail est disponible.",
            "text2": "La page se rafraîchira <1>automatiquement dans 5 minutes.</1>",
            "text3": "Vous pouvez également <1>appliquer la mise à jour immédiatement</1> en cliquant sur <1>MAJ maintenant.</1>",
            "auto_refresh": "MAJ maintenant"
        }
    },
    "toast": {
        "reload_page": {
            "message": "Mise à jour dans 1 minute"
        }
    }
}